/* eslint-disable no-unused-vars */
import React, { Suspense, useContext } from 'react';
import { Canvas } from '@react-three/fiber';
import { PerspectiveCamera } from '@react-three/drei';
import CanvasLoader from './components/CanvasLoader'
import { Leva, useControls } from 'leva';
import { calculateSizes } from './constants/constants';
import ComputerTable from './components/ComputerTable';
import { useMediaQuery } from 'react-responsive';
import HeroCamera from './components/HeroCamera'
import { ReactLogo } from './components/ReactLogo';
import { Barcelona } from './components/Barcelona';
import Pad from './components/Pad';
import Ball from './components/Ball';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from "./context/ThemeContext";



const Hero = () => {

    const { darkMode } = useContext(ThemeContext);

    const isSmall = useMediaQuery({ maxWidth: 440 });
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });

    const sizes = calculateSizes(isSmall, isMobile, isTablet);

    return (
        <div className="h-[70vh] lg:h-screen w-full flex flex-col relative pt-14 lg:pt-0" id="home">
            <div className='w-full mx-auto flex flex-col lg:-mb-20 lg:mt-24 mt-4 c-space gap-3 text-center sm:text-3xl text-xl font-medium font-generalsans'>
                <h1 className=''>Hi, I am Samuel</h1>
                <h1>Cloud Developer</h1>
            </div>
            <div className="w-full lg:h-full h-[60%] inset-0">
                <Leva hidden/>
                <Canvas className="">
                    <Suspense fallback={<CanvasLoader />}>
                        <PerspectiveCamera makeDefault position={[0, 0, 30]} />
                        <group>
                            <ReactLogo scale={sizes.logoScale} position={sizes.reactLogoPosition} />
                            {/* <Barcelona scale={sizes.barcaScale} position={sizes.barcaLogoPosition} /> */}
                            {/* <Pad rotation={[0, 1, 6]} scale={sizes.padScale} position={sizes.ballPosition}/> */}
                            {/* <Ball scale={sizes.ballScale} position={sizes.ballPosition}/> */}
                        </group>
                        <HeroCamera isMobile={isMobile}>
                            <ComputerTable scale={sizes.computerDeskScale} position={sizes.deskPosition} rotation={[0.3, -Math.PI / 1000, 0]} />
                        </HeroCamera>
                        <ambientLight intensity={1} />
                        <directionalLight position={[10, 10, 10]} intensity={0.5} />
                        <directionalLight position={[5, 0, 10]} intensity={1} />
                        <directionalLight position={[-5, 0, 10]} intensity={1} />

                        <spotLight position={[10, 10, 10]} angle={0.2} penumbra={0.5} intensity={0.7} castShadow />
                        <spotLight position={[-10, 10, 10]} angle={0.2} penumbra={0.5} intensity={0.7} castShadow />
                    </Suspense>
                </Canvas>
            </div>
            <div className='flex flex-col gap-5 items-center justify-center mt-16'>
                <a href='Samuel Ajayi CV.pdf' download='Samuel Ajayi CV.pdf' target='_blank' rel="noreferrer" className={`${darkMode ? " text-white border-white" : "text-black border-black"} border rounded-md px-4 py-2 hover:scale-110`}>My CV</a>

                <div className='flex items-center gap-5'>
                    <a href='https://github.com/samuelajayii' target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faGithub} className='text-2xl'/></a>
                    <a href='https://www.linkedin.com/in/samuel-ajayi-671ab124a' target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} className='text-2xl'/></a>
                    <a href='mailto:ajayisamuel023@gmail.com' target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faEnvelope} className='text-2xl'/></a>
                    
                </div>
            </div>

        </div>
    );
}

export default Hero;